import { render, staticRenderFns } from "./ProductCardList.vue?vue&type=template&id=0b4b4c37"
import script from "./ProductCardList.vue?vue&type=script&lang=js"
export * from "./ProductCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4b4c37')) {
      api.createRecord('0b4b4c37', component.options)
    } else {
      api.reload('0b4b4c37', component.options)
    }
    module.hot.accept("./ProductCardList.vue?vue&type=template&id=0b4b4c37", function () {
      api.rerender('0b4b4c37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ProductCardList.vue"
export default component.exports